// extracted by mini-css-extract-plugin
export default {"homeLayout":"HomeLayout_homeLayout__f4ch0","mainContent":"HomeLayout_mainContent__QBxwU"};